import {useContext} from 'react'

import FormContext from './FormContext'

const useFormContext = () => {
  const form = useContext(FormContext)
  if (!form) {
    throw new Error('Missing FormContextProvider in its parent.')
  }
  return form
}

export default useFormContext
